import React from 'react';
import { ToastContainer, ToastContainerProps } from 'react-toastify';
import { useSidebar } from 'src/presentations/components/organisms/sidebar/useSidebar';

/**
 * A wrapper for react-toastify's ToastContainer that automatically adjusts
 * its position based on the sidebar width to prevent overlap.
 */
const SidebarAwareToastContainer: React.FC<ToastContainerProps> = ({ position, style, ...restProps }) => {
  const { sidebarWidth } = useSidebar();

  // Create a style object with dynamic left margin based on sidebar width
  const containerStyle = {
    // Only apply left margin for bottom-left position (default position)
    ...(!position || position === 'bottom-left'
      ? {
          left: `${sidebarWidth + 16}px`, // Add some padding (16px)
        }
      : {}),
  };

  return (
    <ToastContainer
      position={position}
      style={{
        ...style,
        ...containerStyle,
      }}
      {...restProps}
    />
  );
};

export default SidebarAwareToastContainer;
